function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

/* script */
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
import { setDay } from 'date-fns';
import { DATE_STYLE } from '../constant';
import { formatDate } from '../utils';
var __vue_script__ = {
  name: 'DateTHead',
  props: {
    prefixCls: {
      type: String,
      default: undefined
    },
    value: {
      type: Date,
      default: undefined
    },
    selectedValue: {
      type: [Date, Array],
      default: undefined
    },
    locale: {
      type: Object,
      default: undefined
    },
    showWeekNumber: {
      type: Boolean,
      default: false
    }
  },
  computed: {
    weekDays: function () {
      var value = this.value,
          _this$locale = this.locale,
          DateFnsLocale = _this$locale.DateFnsLocale,
          weekStartsOn = _this$locale.WeekLocale.weekStartsOn,
          localeWeek = _this$locale.week,
          showWeekNumber = this.showWeekNumber;
      var cols = DATE_STYLE.col;
      var weekDays = [];

      if (showWeekNumber) {
        weekDays.push({
          id: -1,
          title: localeWeek,
          name: '',
          isWeek: true
        });
      }

      for (var i = 0; i < cols; i += 1) {
        var idx = (i + weekStartsOn) % cols;
        var weekDay = setDay(value, idx);
        weekDays.push({
          id: i,
          title: formatDate(weekDay, 'dddd', {
            locale: DateFnsLocale
          }),
          name: formatDate(weekDay, 'dd', {
            locale: DateFnsLocale
          })
        });
      }

      return weekDays;
    }
  },
  methods: {
    cellClasses: function cellClasses(cell) {
      var _ref;

      var prefixCls = this.prefixCls;
      var isWeek = cell.isWeek;
      return _ref = {}, _defineProperty(_ref, "".concat(prefixCls, "-column-header"), true), _defineProperty(_ref, "".concat(prefixCls, "-week-number-header"), isWeek), _ref;
    }
  }
};
/* template */

var __vue_render__ = function () {
  var _vm = this;

  var _h = _vm.$createElement;

  var _c = _vm._self._c || _h;

  return _c('thead', [_c('tr', {
    attrs: {
      "role": "row"
    }
  }, _vm._l(_vm.weekDays, function (w, i) {
    return _c('th', {
      key: i,
      class: _vm.cellClasses(w),
      attrs: {
        "title": w.title,
        "role": "columnheader"
      }
    }, [_c('span', {
      class: _vm.prefixCls + "-column-header-inner"
    }, [_vm._v("\n        " + _vm._s(w.name) + "\n      ")])]);
  }), 0)]);
};

var __vue_staticRenderFns__ = [];
/* style */

var __vue_inject_styles__ = undefined;
/* scoped */

var __vue_scope_id__ = undefined;
/* module identifier */

var __vue_module_identifier__ = undefined;
/* functional template */

var __vue_is_functional_template__ = false;
/* component normalizer */

function __vue_normalize__(template, style, script, scope, functional) {
  var component = (typeof script === 'function' ? script.options : script) || {}; // For security concerns, we use only base name in production mode.

  component.__file = "dateTHead.js";

  if (!component.render) {
    component.render = template.render;
    component.staticRenderFns = template.staticRenderFns;
    component._compiled = true;
    if (functional) component.functional = true;
  }

  component._scopeId = scope;
  return component;
}
/* style inject */

/* style inject SSR */


export default __vue_normalize__({
  render: __vue_render__,
  staticRenderFns: __vue_staticRenderFns__
}, __vue_inject_styles__, __vue_script__, __vue_scope_id__, __vue_is_functional_template__, __vue_module_identifier__, undefined, undefined);